import script from "./HomeLanding.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeLanding.vue?vue&type=script&setup=true&lang=js"

import "./HomeLanding.vue?vue&type=style&index=0&id=9880940c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9880940c"]])

export default __exports__